module.exports = __webpack_public_path__ + "img/eye_blue.6618cd6e.svg";